import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TEST_ID = 'icon-basketball';

export const BasketballColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={TEST_ID}
        >
            <g id="Basketball" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M19.213 19.213c-3.937 3.938-10.322 3.938-14.26 0-3.937-3.937-3.937-10.322 0-14.26 3.938-3.937 10.323-3.937 14.26 0 3.938 3.938 3.938 10.323 0 14.26z"
                    fill="#FD8259"
                />
                <path
                    d="M19.782 4.221c-4.29-4.295-11.274-4.295-15.564 0-4.29 4.295-4.29 11.288 0 15.583C6.313 21.9 9.206 23 12 23c2.794 0 5.587-1.099 7.782-3.196 4.29-4.295 4.29-11.288 0-15.583zm.3 3.896c.399.899.698 1.898.798 2.897h-3.193c0-.3-.1-.7-.1-1 1.198-.199 1.996-.898 2.495-1.897zM18.385 5.62l.3.3c-.1 1.498-.699 1.997-1.497 2.097-.598-1.698-1.496-3.396-2.893-4.795 1.397.5 2.893 1.2 4.09 2.398zm-7.582-2.497c.698.4 1.397.899 1.995 1.498a10.034 10.034 0 0 1 2.195 3.296c-1.197-.3-2.195-.999-3.292-1.798-1.198-.799-2.395-1.598-3.891-2.097.997-.5 1.895-.8 2.993-.9zM5.615 5.62c1.995.1 3.392 1.099 4.888 2.097 1.497 1 3.093 2.098 5.089 2.398.1.3.1.599.1.899H3.12c.2-1.998.998-3.896 2.495-5.394zm0 12.785C4.118 16.907 3.32 15.01 3.12 13.011h12.671c0 .3-.1.6-.1.9-2.095.2-3.591 1.298-5.088 2.397-1.596.998-2.993 1.997-4.988 2.097zm5.188 2.497a7.52 7.52 0 0 1-2.894-.899c1.497-.499 2.694-1.298 3.792-2.097 1.097-.8 2.195-1.499 3.292-1.798a10.034 10.034 0 0 1-2.195 3.296c-.598.5-1.297 1.099-1.995 1.498zm7.582-2.497c-1.197 1.199-2.594 1.998-4.09 2.298 1.397-1.399 2.295-2.997 2.893-4.795.798.1 1.397.6 1.497 2.098-.1.1-.2.3-.3.4zm1.697-2.597c-.5-.999-1.397-1.598-2.495-1.898.1-.3.1-.599.1-.999h3.193c-.1 1.1-.4 1.998-.798 2.897z"
                    fill="#0C0D0E"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};

BasketballColored.TEST_ID = TEST_ID;
